/** Marca o campo como _deleted em vez de remover; usado para histórico de métricas. Não é enviado ao flow. */
export const handleRemoveFieldInGroup = (
  groupId: string | undefined,
  fieldId: string,
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  uuid: string,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const markDeletedRecursively = (items: any[]): any[] => {
    return items.map((item: any) => {
      if (item.uuid === groupId && item.children) {
        return {
          ...item,
          children: markDeletedRecursively(item.children).map((field: any) =>
            field.uuid === fieldId ? { ...field, _deleted: true } : field
          ),
        };
      }
      if (item.children) {
        return {
          ...item,
          children: markDeletedRecursively(item.children),
        };
      }
      return item;
    });
  };

  const newItems = markDeletedRecursively(form);
  setForm(newItems);
  setButtonSave(true);
};
